module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-container"
  }, [_c('gmap-map', {
    ref: "map",
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "mapTypeId": _vm.mapTypeId
    },
    on: {
      "zoom_changed": function($event) {
        _vm.$store.dispatch('viewport/update', {
          what: 'zoom',
          e: $event
        })
      },
      "center_changed": function($event) {
        _vm.$store.dispatch('viewport/update', {
          what: 'center',
          e: $event
        })
      },
      "maptypeid_changed": function($event) {
        _vm.$store.dispatch('viewport/update', {
          what: 'mapTypeId',
          e: $event
        })
      }
    }
  }, [_c('SearchResults'), _vm._v(" "), _c('SearchDetailedResult'), _vm._v(" "), _c('ProjectMarkers'), _vm._v(" "), _c('ProjectMarkerInfo'), _vm._v(" "), _c('ProjectDotInfo'), _vm._v(" "), _c('ProjectPolygonInfo')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "rp-modal"
    }
  }, [(_vm.projectInitialized && _vm.isReady) ? _c('div', [_c('Project'), _vm._v(" "), _c('SearchBox'), _vm._v(" "), _c('ToolBox')], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "rp-modal"
    }
  }, [(!_vm.projectInitialized && _vm.isReady) ? [_c('Manager')] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "rp-modal"
    }
  }, [_c(_vm.modalWindowComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.modalWindowProps))], 1), _vm._v(" "), _c('Toastr'), _vm._v(" "), _c('Router')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fa4ba9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 476
// module chunks = 0